<template>
  <div class="scroll popups" @click.stop="close" v-show="showPopup">
    <div
      class="bg-FFFFFF w-full fb fb-col popup"
      :class="showPopup ? 'show-popups' : 'hide-popups'"
      @click.stop="handlerClickPopup"
    >
      <div
        class="bb font-32 lh-44 w-full fb fb-cross-center fb-main-between fb-row popup-header"
      >
        <div class="monthly-title monthly-left" @click="methodYearChange(-1)">
          <i class="iconfont c-191F25-28 font-34 inline-block w-50 text-center"
            >&#xe600;</i
          >
        </div>
        <div class="monthly-title month-content ff-semibol c-191F25-56"
          >{{ year }}年</div
        >
        <div class="monthly-title monthly-right" @click="methodYearChange(1)"
          ><i class="iconfont c-191F25-28 font-34 inline-block w-50 text-center"
            >&#xe601;</i
          >
        </div>
      </div>
      <div class="ff-regular w-full p-16-0 popup-content">
        <div
          v-for="(item, index) in months"
          @click="
            handlerChooseMonth(
              item,
              passed &&
                (+nowYearMonth < +`${year}${item}` ||
                  limitTime > +`${year}${item}`)
            )
          "
          :key="index"
          class="inline-block text-center lh-50 font-32 monthly-content"
          :class="calcClass(item)"
          >{{ +item }}月
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: true
    },
    passed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopup: this.show,
      months: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
      ],
      year: new Date().getFullYear(),
      month: `0${new Date().getMonth() + 1}`.slice(-2),
      nowYearMonth: null,
      limitTime: +`${new Date().getFullYear() - 1}${`0${
        new Date().getMonth() + 1
      }`.slice(-2)}`,
      changeType: null
    }
  },
  computed: {},
  watch: {
    show(show) {
      this.showPopup = show
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.nowYearMonth = `${this.year}${this.month}`
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    calcClass(item) {
      if (
        this.passed &&
        (+this.nowYearMonth < +`${this.year}${item}` ||
          this.limitTime > +`${this.year}${item}`)
      ) {
        return 'c-191F25-28'
      } else if (+this.month === +item) {
        return 'c-006AFE'
      } else {
        return 'c-006AFE-72'
      }
    },
    close() {
      this.showPopup = false
      this.$emit('close', false, this.year, this.month)
    },
    // type -1:去年 1: 明年
    methodYearChange(type) {
      // 只能前进一次或者后退一次
      let currentYear = new Date().getFullYear()
      if (
        this.year + type <= currentYear &&
        this.year + type >= currentYear - 1
      ) {
        this.changeType = type
        this.year = this.year + type
      }
    },
    // 选择月份
    handlerChooseMonth(month, disabled) {
      if (disabled) {
        return false
      }
      this.month = `0${month}`.slice(-2)
      this.close()
    },
    handlerClickPopup() {
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.popups {
  background: rgba(0, 0, 0, 0.28);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999999;
  .popup {
    transition: all ease 0.6s;
    position: absolute;
    left: 0;
    bottom: -100vh;
    max-height: 80%;
    width: 100%;
  }
  .popup-close {
    position: absolute;
    top: 23px;
    transform: translateY(-50%);
    right: -16px;
    padding: 0 16px;
  }
  .hide-popups {
    bottom: -100vh;
  }
  .show-popups {
    bottom: 0;
  }
  .monthly-content {
    width: 25%;
  }
  .disabled {
    background-color: rgba(25, 31, 37, 0.06);
  }
}
</style>
